export const returnsIntakeTags = [
  'ShippingWithReturnsIntake',
  'ReturnsIntake',
] as const;
